import { h } from "preact";
import { useState, useContext } from "preact/hooks";
import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import { AppContext } from "../../AppContext";


import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
const useStyles = makeStyles({
	table: {
		minWidth: 650,
	},
});
export default function Deal1({ upperState, setUpperState, mode }) {
	const classes = useStyles();
	const [state, setState] = useState(upperState);
	const app = useContext(AppContext);

	return (
		<div>

			<Box display="flex" justifyContent="space-between" alignItems="center" style="margin-bottom: 20px;">
				<Box>
					<Typography variant="h5">Liste du ou des vendeurs</Typography>
				</Box>

				<Box>
					{upperState.sellers && upperState.sellers.length > 0 && (
						<Button variant="outlined" onClick={() => {
							app.refPopUp.current.handleChangeState(
								{
									opened: true,
									type: "008",
									uid: upperState.uid,
									mode: "VN",
									users: upperState.sellers,
									src: "dl",
									side: "VN"

								}
							)
						}}>
							Ajouter un vendeur
						</Button>
					)}{" "}
				</Box>
			</Box>

			{upperState.sellers && upperState.sellers.length === 0 && (
				<Box
					display="flex"
					alignItems="center"
					justifyContent="center"
					style="margin-bottom: 10px;   margin-top: 100px;"
					flexDirection="column"
				>
					<Box>
						<Typography variant="h6" style="margin-bottom: 30px;">
							Vous n'avez encore défini aucun vendeur dans ce dossier de vente
						</Typography>
					</Box>
					<Box>
						<Button variant="contained" onClick={() => {
							app.refPopUp.current.handleChangeState(
								{
									opened: true,
									type: "008",
									uid: upperState.uid,
									mode: "VN",
									src: "dl",
									side: "VN"

								}
							)
						}}>
							Ajouter un vendeur
						</Button>
					</Box>
				</Box>
			)}
			<Stack spacing={1} direction="column" justifyContent="space-between" style="min-height: 300px;">
				{upperState.sellers && upperState.sellers.length > 0 && (
					<TableContainer component={Paper}>
						<Table className={classes.table} size="small" aria-label="a dense table">
							<TableBody>
								{upperState.sellers &&
									upperState.sellers.map((row) => (
										<TableRow key={row.uid}>
											<TableCell component="th" scope="row">
												{row.name}
											</TableCell>
											<TableCell align="left">{row.e}</TableCell>
											<TableCell align="left">
												{row.proxied && row.proxied.length > 0 && (
													<Typography variant="body2">Représente</Typography>
												)}
												{row.proxied && row.proxied.map((prx) => <Typography variant="body1">- {prx.n}</Typography>)}
											</TableCell>

											<TableCell align="right">
												<DeleteForeverIcon
													onClick={() => {
														app.refPopUp.current.handleChangeState(
															{
																opened: true,
																type: "009",
																params: {
																	uid: row.uid,
																	name: row.name
																}
															}
														)
													}}
												/>
											</TableCell>
										</TableRow>
									))}
							</TableBody>
						</Table>
					</TableContainer>
				)}
				<Box display="flex" justifyContent="space-between" alignItems="flex-end">
					<Box></Box>
					<Box>
						{upperState.sellers && upperState.sellers.length > 0 && (
							<Button
								variant="contained"
								onClick={() => {
									switch (upperState.mode) {
										case "AM":
											window.location.href = "/newdeala/" + upperState.uid + "/4";
											break;
										case "VN":
											window.location.href = "/newdealv/" + upperState.uid + "/4";
											break;
									}
								}}
							>
								Continuer
							</Button>
						)}
					</Box>
				</Box>
			</Stack>
		</div>
	);
}
